module.exports = "/virtual-football-league/img/amblems/right/logos/Fake_Bournmouth.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Fake_Bournmouth.png
// module id = 2180
// module chunks = 4